/**
 * Breakpoints - Standardized responsive breakpoints for Green Filter
 * Use these for consistent responsive behavior across all components
 */

export const BREAKPOINTS = {
  mobile: '640px',
  tablet: '768px',
  desktop: '1024px',
} as const;

// Helper for media queries
export const media = {
  mobile: `@media (max-width: ${BREAKPOINTS.mobile})`,
  tablet: `@media (max-width: ${BREAKPOINTS.tablet})`,
  desktop: `@media (min-width: ${BREAKPOINTS.desktop})`,
} as const;

export type BreakpointName = keyof typeof BREAKPOINTS;
